import Axios from 'axios';
import store from '@/Client/Store';

const coreApiInstance = Axios.create({
  baseURL: process.env.CORE_API_URL + '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

const authInstance = Axios.create({
  baseURL: process.env.CORE_API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

coreApiInstance.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (!error.response) {
    return Promise.reject(error);
  }
  if (error.response.status === 401) {
    store.dispatch('logout').then(() => {
      window.location.href = '/login';
    }).catch((err) => {
      console.error('Axios interceptors have been incorrectly configured:', err.message);
    });
    return Promise.reject(error);
  }
  if (error.response.status === 403) {
    store.dispatch('setForbiddenError', true);
    return Promise.reject(error);
  }
  return Promise.reject(error);
});

export default {
  coreApiInstance,
  authInstance,
};
